import { Component, ElementRef, Input, OnChanges, AfterViewInit, SimpleChanges } from '@angular/core';

export type NcSpeedType = 'verySlow' | 'slow' | 'default' | 'fast' | 'veryFast';

@Component({
  selector: 'nc-wave-progress',
  templateUrl: './wave-progress.component.html',
  styleUrls: ['./wave-progress.component.less']
})
export class WaveProgressComponent implements AfterViewInit, OnChanges {
  /** 进度 */
  @Input() ncPercent: number = 0;
  /** 宽度 */
  @Input() ncWidth: number = 132;
  /** 边框颜色 */
  @Input() ncBorderColor: string = '#1890ff';
  /** 文字颜色 */
  @Input() ncColor: string = '#000000d9';
  /** 波浪颜色 */
  @Input() ncWaveColor: string = '#74bcff';
  /** 是否显示文字 */
  private _showInfo: boolean = true;
  @Input() set ncShowInfo(value: boolean | string) {
    this._showInfo = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  get ncShowInfo(): boolean {
    return this._showInfo;
  }
  /** 波浪速度 */
  @Input() ncSpeed: NcSpeedType = 'default';

  borderWidth: number = 5;//计算
  fontSize: number = 32;//计算
  speedType: any = {
    veryFast: 2,
    fast: 4,
    default: 6,
    slow: 8,
    verySlow: 10
  };

  constructor(private eleRef: ElementRef) { }

  ngAfterViewInit(): void {
    this.setTop();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['ncPercent'] && !changes['ncPercent'].firstChange) {
      this.setTop();
    }
  }

  setTop() {
    this.eleRef.nativeElement.querySelector('.wave').style.top = `${this.ncWidth * (1 - this.ncPercent / 100)}px`;
    this.fontSize = Math.round(this.ncWidth * 0.24);
    this.borderWidth = Math.round(this.ncWidth * 0.038);
  }
}